export const MAX_SOURCES = 10;
export const MAX_OBSTACLES = 8;

export const MIN_VISIBLE_INTENSITY = 0.001;
export const MIN_OPACITY_THRESHOLD = 0.001;

export const PRETTY_COLORS = [
  { r: 0.95, g: 0.80, b: 0.81 }, // Pastel Pink
  { r: 0.80, g: 0.89, b: 0.95 }, // Pastel Blue
  { r: 0.87, g: 0.95, b: 0.80 }, // Pastel Green
  { r: 0.95, g: 0.95, b: 0.80 }, // Pastel Yellow
  { r: 0.95, g: 0.87, b: 0.73 }, // Pastel Peach
  { r: 0.89, g: 0.80, b: 0.95 }, // Pastel Lavender
  { r: 0.80, g: 0.95, b: 0.91 }, // Pastel Mint
  { r: 0.95, g: 0.85, b: 0.95 }, // Pastel Lilac
  { r: 0.89, g: 0.82, b: 0.75 }, // Pastel Taupe
  { r: 0.84, g: 0.95, b: 0.88 },  // Pastel Seafoam

  // Neon colors
  { r: 1.0, g: 0.0, b: 1.0 },   // Neon Pink
  { r: 0.0, g: 1.0, b: 0.0 },   // Neon Green
  { r: 1.0, g: 0.8, b: 0.0 },   // Neon Orange
  { r: 0.0, g: 1.0, b: 1.0 },   // Neon Cyan
  { r: 1.0, g: 0.0, b: 0.0 },   // Neon Red
  { r: 0.5, g: 0.0, b: 1.0 },   // Neon Purple
  { r: 0.8, g: 1.0, b: 0.0 },   // Neon Lime
  { r: 1.0, g: 0.0, b: 0.5 },   // Neon Magenta
  { r: 0.0, g: 0.5, b: 1.0 },   // Neon Blue
  { r: 1.0, g: 1.0, b: 0.0 },   // Neon Yellow

  // Basic colors
  { r: 1.0, g: 0.0, b: 0.0 },   // Red
  { r: 0.0, g: 1.0, b: 0.0 },   // Green
  { r: 0.0, g: 0.0, b: 1.0 },   // Blue
  { r: 1.0, g: 1.0, b: 1.0 },   // White
]; 